(function () {

    'use strict';

    angular.module('Services')
        .factory('ServicesService', function ($http, $rootScope, Error, Request) {
            return {
                getClientServiceLinks: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.carrier.clientService,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getClientServiceLink: function (id, callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.carrier.clientService + id,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                createClientServiceLink: function (payload, successCallback, errorCallback) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.carrier.clientService,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, payload);
                },
                updateClientServiceLink: function (id, payload, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.clientService + id,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, payload);
                },
                cloneMargin: function (id, callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.carrier.cloneMargin.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    })
                },
                autoCrateMargin: function (payload, successCallback, errorCallback) {
                    Request.post({
                        url: `${ApiURLs.carrier.autoCreateMargin}`,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                }
            }
        }
        );
})();



// WEBPACK FOOTER //
// ./js/services/ServicesService.js